import { Component, inject } from '@angular/core';
import { ActivatedRoute, Router, RouterLink, RouterLinkActive } from '@angular/router';
import { TabGroup, Tab, Select } from 'excellence-ui';
import { NgIcon } from '@ng-icons/core';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-location-details-nav',
  imports: [RouterLink, RouterLinkActive, TabGroup, Tab, NgIcon, Select, TranslocoPipe],
  templateUrl: './location-details-nav.html',
})
export class LocationDetailsNav {
  private activatedRoute = inject(ActivatedRoute);
  private router = inject(Router);

  protected onSelectChange(url: string | string[] | null): void {
    this.router.navigate([url], {
      relativeTo: this.activatedRoute,
    });
  }
}
